import Swiper, { Lazy, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'

import cursor from './cursor'

Swiper.use([Lazy, Pagination])

const commonConfig = {
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 1,
  },
  touchStartPreventDefault: false, // required for correct work of cursor animations
}

const specificConfigs = {
  'rent-buy': {
    speed: 800,
    slidesPerView: 1.2,
    spaceBetween: 8,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
  },
  'client-logos': {
    speed: 400,
    slidesPerView: 'auto',
    spaceBetween: 8,
    breakpoints: {
      640: {
        spaceBetween: 32,
      },
    },
  },
  card: {
    slidesPerView: 1,
    lazy: true,
    preloadImages: false,
    navigation: {
      nextEl: '[data-next]',
      prevEl: '[data-prev]',
    },
    loop: true,
  },
}

const carouselObserver = new IntersectionObserver(entries =>
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      carouselObserver.unobserve(entry.target)
      const adjustments = specificConfigs[entry.target.dataset.carousel] || {}
      const config = { ...commonConfig, ...adjustments } // TODO deep merge breakpoints
      new Swiper(entry.target, config)
      entry.target.addEventListener('mousedown', () => {
        cursor.toggleActiveState(true)
      })
      entry.target.addEventListener('mouseup', () => {
        cursor.toggleActiveState(false)
      })
    }
  })
)

export default carouselObserver
